<template>
  <el-dialog :visible.sync='dialogVisible' width="550" :lock-scroll="false" :modal-append-to-body='false' v-if="dialogVisible" custom-class="custom-radius-dialog">
    <div class="sub-main-w3">
      <div class="vertical-tab">
        <!-- 登录 -->
        <LoginPart @closeDialog='closeDialog'></LoginPart>
        <!-- 注册 -->
        <RegisterPart @closeDialog='closeDialog'></RegisterPart>
        <!-- 重置密码 -->
        <ResetPart @closeDialog='closeDialog'></ResetPart>
      </div>
      <div class="clear"></div>
    </div>
  </el-dialog>
</template>

<script>
import LoginPart from '@/components/dialog/loginPart'
import RegisterPart from '@/components/dialog/registerPart'
import ResetPart from '@/components/dialog/resetPart'

export default {
  components: {
    LoginPart,
    RegisterPart,
    ResetPart
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    // 弹框
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
@import '@/assets/css/style.css';

/* 穿透生效，只影响带 custom-radius-dialog 类的弹窗 */
::v-deep .custom-radius-dialog {
  border-radius: 12px;  /* 自定义圆角大小，按需调整 */
  overflow: hidden;     /* 关键：防止头部/底部背景溢出圆角 */
}

/* 可选：微调关闭按钮位置，圆角变大后更协调 */
::v-deep .custom-radius-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 14px;
}
</style>
